import styled from "styled-components";

export const HeadlineBig = styled.h1`
  color: ${({ theme }) => theme.old.colors.white};
  font-size: ${({ theme }) => theme.old.fonts.size.large};
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
  line-height: 24px;
  margin-bottom: 14px;
`

export const HeadlineMedium = styled.h1`
  color: ${({ theme }) => theme.old.colors.white};
  font-size: ${({ theme }) => theme.old.fonts.size.large};
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
  line-height: 32px;
  margin-bottom: 12px;
`

export const HeadlineSmall = styled.h2`
  color: ${({ theme }) => theme.old.colors.white};
  font-size: ${({ theme }) => theme.old.fonts.size.normal};
  font-weight: ${({ theme }) => theme.old.fonts.weight.regular};
  line-height: 24px;
  margin-bottom: 4px;
`

